import { Navbar, Footer } from "@/components/site-chrome";
import { brand } from "@/lib/brand";
import { motion } from "framer-motion";
import {
  SectionLabel, Reveal,
  WINE, CREAM, CREAM2, CHARCOAL, SAND, FONT_DISPLAY, FONT_SANS,
} from "@/components/landing/editorial-backgrounds";

const GRAIN = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`;

export function AboutPage() {
  return (
    <div className="relative min-h-screen overflow-hidden" style={{ background: CREAM, fontFamily: FONT_SANS }}>
      <div className="pointer-events-none absolute inset-0 opacity-[0.035]" style={{ backgroundImage: GRAIN, backgroundSize: "200px 200px" }} />
      <div className="pointer-events-none absolute inset-0 opacity-50" style={{ backgroundImage: `radial-gradient(circle, ${CHARCOAL}0A 1px, transparent 1px)`, backgroundSize: "32px 32px" }} />
      <div className="absolute top-0 left-0 right-0 h-[3px]" style={{ background: `linear-gradient(90deg, ${WINE}, ${SAND}, ${WINE})` }} />
      <div className="relative z-10">
        <Navbar />
        <section className="mx-auto max-w-3xl px-6 py-24 sm:py-32">
          <SectionLabel label="About" />
          <Reveal delay={0.1}>
            <h1 className="mt-8" style={{ fontFamily: FONT_DISPLAY, color: CHARCOAL, lineHeight: 0.92, letterSpacing: "-0.03em", fontSize: "clamp(2.5rem, 7vw, 5rem)", fontWeight: 700 }}>
              About {brand.name}
            </h1>
            <p style={{ fontFamily: FONT_DISPLAY, color: WINE, lineHeight: 0.92, letterSpacing: "-0.03em", fontSize: "clamp(2.5rem, 7vw, 5rem)", fontWeight: 700, fontStyle: "italic" }}>
              Built in {brand.city}.
            </p>
          </Reveal>
          <div className="mt-10 space-y-6">
            {[
              `${brand.name} is a school payments platform built in ${brand.city}, ${brand.country}. We replace the chaos of cash, cheques and multiple Mobile Money sends with a single consolidated payment that settles every child's fees, transport, meals and uniforms in one tap.`,
              "Our mission is to make school payments invisible — so schools focus on education, parents spend less time queueing, and every shilling is accounted for.",
              "We work with MTN Mobile Money and Airtel Money, support USSD for parents without smartphones, and issue unique transaction references (WTX) for every wallet top-up so disputes resolve in seconds.",
            ].map((p, i) => (
              <Reveal key={i} delay={0.15 + i * 0.1}>
                <p className="text-lg leading-[1.7]" style={{ fontFamily: FONT_DISPLAY, fontStyle: "italic", color: `${CHARCOAL}80` }}>{p}</p>
              </Reveal>
            ))}
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
}
